<template>
  <div class="notice">
    <div
      v-if="$slots.icon"
      class="notice__icon"
    >
      <slot name="icon"></slot>
    </div>

    <div
      v-else
      class="notice__icon"
    >
      <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.1666666666666667,0,0,1.1666666666666667,0,0)"><path d="M0.75 14.25L0.75 23.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M.75,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M6 18.75L9 18.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M7.684,12.816A8.25,8.25,0,1,1,17.021,17" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M14.25 3.75L14.25 9.75 18 9.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
    </div>

    <div class="notice__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice'
};
</script>

<style lang="scss" scoped>
/**
 * Notice
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Notice, used for explaining scenarios with an icon and long text
 * @since 2021-08-26
**/

$component: 'notice';

.#{$component} {
  display: flex;
  align-items: flex-start;
  @include margin-bottom($spacer);
  @include padding(map-get($spacers, 3) map-get($spacers, 3) map-get($spacers, 3) map-get($spacers, 3));
  border-top: 3px solid $yellow;
  border-radius: $border-radius-lg;
  background-color: $sky-lighter;

  &__icon {
    @include rfs(2.8rem, flex-basis);
    aspect-ratio: 1 / 1;
    flex-shrink: 0;
    @include margin-right(map-get($spacers, 3));
    @include padding(map-get($spacers, 2));
    border-radius: 50%;
    background-color: $yellow;

    svg {
      width: 100%;
      height: auto;
      aspect-ratio: 1 / 1;
      color: $ink-light;

      path {
        stroke: $ink-light;
      }
    }
  }

  &__content {
    color: $ink-light;

    > p:last-child {
      margin-bottom: 0;
    }
  }

  &__title {
    color: $ink;
    @include font-size($font-size-lg);
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__icon {
      @include rfs(4rem, flex-basis);
    }
  }
}
</style>
